const zonedDateTimePattern = /(Z|[+-]\d{2}:\d{2})$/i;
const localDateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/;

export function shanghaiDateTimeToIso(value: string) {
  const input = value.trim();
  const candidate = zonedDateTimePattern.test(input)
    ? input
    : localDateTimePattern.test(input)
      ? `${input}+08:00`
      : "";
  const parsed = candidate ? new Date(candidate) : new Date(Number.NaN);
  if (Number.isNaN(parsed.getTime())) throw new Error("请选择有效的课程时间。");
  return parsed.toISOString();
}

export function scheduleWindowError(startValue: string, endValue: string) {
  let start: Date;
  let end: Date;
  try {
    start = new Date(shanghaiDateTimeToIso(startValue));
    end = new Date(shanghaiDateTimeToIso(endValue));
  } catch (error) {
    return error instanceof Error ? error.message : "请选择有效的课程时间。";
  }
  if (end.getTime() <= start.getTime()) return "结束时间必须晚于开始时间。";
  const durationMinutes = (end.getTime() - start.getTime()) / 60000;
  if (![60, 90, 120].includes(durationMinutes))
    return "课程时长仅支持60、90或120分钟。";
  if (shanghaiDate(start) !== shanghaiDate(end))
    return "课程开始和结束必须在同一天，请分开排课。";
  return "";
}

function shanghaiDate(value: Date) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(value);
}
